import { Selection } from '@tiptap/pm/state';
import { Editor } from '@tiptap/core';

function defaultBlockAt(match: any) {
  for (let i = 0; i < match.edgeCount; i++) {
    const { type } = match.edge(i);
    if (type.isTextblock && !type.hasRequiredAttrs()) return type;
  }
  return null;
}

export default function exitBlockAbove(editor: Editor, nodeName: string) {
  const { state } = editor;
  const { selection } = state;
  const { dispatch } = editor.view;
  const { $anchor, $head } = selection;
  const isAtStart = $anchor.pos === 1;
  if ($anchor.parent.type.name !== nodeName || !isAtStart) {
    return false;
  }

  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
  const above = $head.node(-1),
    before = $head.index(-1),
    type = defaultBlockAt(above.contentMatchAt(before));
  if (!type || !above.canReplaceWith(before, before, type)) return false;
  if (dispatch) {
    const pos = $head.before(),
      tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(Selection.near(tr.doc.resolve(pos), -1));
    dispatch(tr.scrollIntoView());
  }
  return true;
}

export { defaultBlockAt, exitBlockAbove };
